import { render, staticRenderFns } from "./CommonPermissions.vue?vue&type=template&id=73d09fce"
import script from "./CommonPermissions.vue?vue&type=script&lang=js"
export * from "./CommonPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports